import { Navigate } from "react-router-dom";
import { authClient } from "@/lib/auth-client";
import { Loader2 } from "lucide-react";

export function RootRedirect() {
  const { data: orgs, isPending } = authClient.useListOrganizations();

  if (isPending) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (orgs?.length) {
    return <Navigate to={`/${orgs[0].id}/${orgs[0].slug}/dashboard`} replace />;
  }

  return <Navigate to="/onboarding/create-org" replace />;
}
